import { PageTestUtils } from './page-test-utils.js';

export class TestUtils {
  pageBlock = new PageTestUtils();
}
